// Single source of truth for form input styling. Both EstimateModal and
// ClientIntakeModal previously duplicated this string; import from here so
// any tweak to focus ring, padding, or radius lands in one place.
//
// Phase 8 polish:
//   - focus ring uses brand red at 20% alpha (subtle, not harsh)
//   - border morphs to brand red on focus
//   - placeholder text tinted slate-400 for hierarchy
//   - transition timing inherits the global :root rule (uses --ease-soft)
export const inputCls =
    'w-full border border-slate-200 rounded-lg px-3 py-2.5 text-sm bg-white ' +
    'focus:outline-none focus:ring-2 focus:ring-red-500/20 focus:border-red-400 ' +
    'placeholder:text-slate-400 ' +
    'disabled:bg-slate-50 disabled:text-slate-500 disabled:cursor-not-allowed';

// Same look but for textareas with multiline content.
export const textareaCls = inputCls + ' leading-relaxed';

// Error variant — softer red border + ring, doesn't shout.
export const inputErrorCls =
    'border-red-300 focus:border-red-500 focus:ring-red-500/30';
